// Cases.js

import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import DynamicTable from "../../data/DynamicTable/dynamicTable";
import { allCasesView } from "../../data/Axios/queries";
import { caseManagementUrl } from "../../config";
import CasesForm from "./Form";
import { CasesColumns } from "../../data/DynamicTable/Collumns";
import { UploadDocumentComponent } from "../../data/DynamicTable/Modal";
import { useTheme } from "@emotion/react";
import { tokens } from "../../theme";
import { downloadCaseFile } from "../../data/DynamicTable/DynamicFunctions";
import { CloudUploadIcon } from "lucide-react";

const base_url = caseManagementUrl.uri;
const actions = {
  entity: "Cases",
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "File New Case",
    Show_Button: true,
    permission: "CreatePermission",
    inputObjectName: "createCaseDynamic",
    InputObject: "newCase",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
    inputObjectName: "acivateDeactivateCase",
  },
  ViewCase: {
    key: "VIEWDETAILS",
    button_name: "View Details",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  updateCaseStatus: {
    key: "UPDATECASESTATUS",
    button_name: "Update Case Status",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  modelName: "Cases",
  showStatus: true,
};

function Cases() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleOpenModal = () => {
    setDialogOpen(true);
  };

  const handleDownload = async () => {
    await downloadCaseFile();
  };

  return (
    <Box m="2px" p="1rem">
      <>
        <Box
          m="2px"
          sx={{
            justifyContent: "end",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Typography
            style={{ color: colors.greenAccent[400], margin: "0 8px" }}
          >
            Import Case File(s)
          </Typography>
          <Button
            variant="contained"
            size="sm"
            sx={{
              backgroundColor: colors.greenAccent[500],
              borderRadius: "4px",
            }}
            component="label"
            role={undefined}
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
            onClick={handleOpenModal}
          >
            <Typography style={{ color: colors.primary[400], margin: "0 8px" }}>
              Import
            </Typography>
          </Button>
        </Box>
        <DynamicTable
          title="Case Management"
          subtitle="View all cases, create edit or view details"
          columns={CasesColumns}
          FormComponent={CasesForm}
          query={allCasesView}
          base_url={base_url}
          actions={actions}
        />
        <UploadDocumentComponent
          uploadType="case"
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
        />
      </>
      {/* //)} */}
    </Box>
  );
}

export default Cases;
